<template>
  <div class="iframe-room-manager">
    <iframe
      v-if="iframeUrl"
      :src="iframeUrl"
      width="100%"
      frameborder="0"
      style="z-index: 10;"
    ></iframe>
  </div>
</template>
<script>
import { blockUi, unblockUi } from "@/shared/global";
import mushroomDuLich from "../../../service/api/dulich-api";
export default {
  data() {
    return {
      iframeUrl: "",
    };
  },
  methods: {
    async fn_getURL() {
      blockUi();
      let hasRestriction = false;
      try {
        let dataFilter = {
          filters: "nguoi_tao_id=$$user_id",
        };
        
        const ddatListRes = await mushroomDuLich.diem_den_an_toan.listAsync(dataFilter);
        if (!ddatListRes.result || ddatListRes.result.length === 0) {
          hasRestriction = true;
          return;
        }
        
        const ddat = ddatListRes.result[0] || {};
        const duLieuKhaiBao = ddat.du_lieu_khai_bao || {};
        const userLoai = duLieuKhaiBao.user_loai;
        
        const validTypes = [
          "hotel",
          "tourist_villa",
          "tourist_apartment",
          "tourist_cruise",
          "tourist_area",
          "motel",
          "homestay",
          "camping",
        ];
        
        if (!userLoai || !validTypes.includes(userLoai)) {
          hasRestriction = true;
          return;
        }
        
        const { result } = await mushroomDuLich.gotadi.get_gotadi_sso_urlAsync({});
        this.iframeUrl = result.redirectUrl;
      } catch (err) {
        console.error("Lỗi lấy URL hoặc thông tin tài khoản:", err);
        window.toastr.error("Có lỗi xảy ra khi lấy URL.");
      } finally {
        unblockUi();
        if (hasRestriction) {
          this.showRestrictionAlert();
        }
      }
    },
    showRestrictionAlert() {
      this.$confirm(
        "Tính năng Quản lý phòng chỉ dành cho tài khoản thuộc loại hình Cơ sở lưu trú.<br/><br/>Vui lòng kiểm tra lại thông tin tài khoản.",
        "Tính năng bị giới hạn",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "Đã hiểu",
          showClose: false,
          showCancelButton: false,
          type: "warning",
        }
      ).then(() => {
        this.$router.push({
          name: "Admin-ThongTinDDAT-detail",
        });
      });
    },
  },

  created() {
    this.fn_getURL();
  },
};
</script>
<style lang="scss">
.iframe-room-manager {
  iframe {
    height: calc(100vh - 110px);
  }
}
</style>
